/**
 * @file CanvasToolbar.tsx
 * @description Панель над канвой конструктора (phase19.16 Р1-6а;
 * uiux-builder-shell.md §2.1): ширина (общий `DeviceSwitch` — тот же, что в
 * предпросмотре экранов вида сайта), «Черновик | Сейчас на сайте», масштаб
 * «По ширине | 100 %» (на ≈44 % текст мелкий — §7 риск 11) и «на весь
 * экран». Пока смотрят дизайн или прошлую версию — переключателя «Черновик
 * | Сейчас» нет, вместо него полоса с действием. «На весь экран» — до 1280
 * (на компьютере то же делает «Весь сайт ↗» в шапке).
 */

import { Maximize2 } from "lucide-react";

import { Button } from "../../ui/button";
import { DeviceSwitch } from "../../site-view/preview/DeviceSwitch";
import { Segmented } from "../../site-view/Segmented";
import { PREVIEW_WIDTHS, type PreviewMode, type PreviewWidth } from "../../../lib/site-view/preview";

export type CanvasScale = "fit" | "actual";

interface Props {
  width: PreviewWidth;
  onWidth: (width: PreviewWidth) => void;
  mode: PreviewMode;
  onMode: ((mode: PreviewMode) => void) | null;
  scale: CanvasScale;
  onScale: (scale: CanvasScale) => void;
  onFullscreen: () => void;
}

export function CanvasToolbar({ width, onWidth, mode, onMode, scale, onScale, onFullscreen }: Props) {
  return (
    <div className="flex shrink-0 flex-wrap items-center gap-2">
      <DeviceSwitch devices={PREVIEW_WIDTHS} value={width} onChange={onWidth} />
      {onMode ? (
        <Segmented
          aria-label="Что показать"
          options={[
            { value: "draft", label: "Черновик" },
            { value: "live", label: "Сейчас на сайте" },
          ]}
          value={mode}
          onChange={onMode}
        />
      ) : null}
      {width > 360 ? (
        <Segmented
          aria-label="Масштаб сайта"
          className="max-xl:hidden"
          options={[
            { value: "fit", label: "По ширине" },
            { value: "actual", label: "100 %" },
          ]}
          value={scale}
          onChange={onScale}
        />
      ) : null}
      <Button variant="ghost" size="icon" className="ml-auto xl:hidden" onClick={onFullscreen} aria-label="Сайт на весь экран" title="Сайт на весь экран">
        <Maximize2 aria-hidden />
      </Button>
    </div>
  );
}
